<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Add Collection</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)">
        <div class="form-row">
          <b-col md="12">
            <base-input label="Collection Name"
                        name="name"
                        type="textarea"
                        placeholder="Collection Name"
                        success-message="Looks good!"
                        rules="required"
                        v-model="model.title">
            </base-input>
          </b-col>
          <b-col md="12">
            <label class="form-control-label">
              Collection Description
            </label>
            <html-editor
              rules="required"
              v-model="model.description">
            </html-editor>
          </b-col>
          <b-col md="6">
             <div class="dropzone-header">
                <vue2Dropzone
                  v-on:vdropzone-file-added="fileAdded"
                  v-on:vdropzone-max-files-exceeded="maxFilesExceeded"
                  id="imageDropzone"
                  :options="dropzoneOptions"
                  ref="image"
                />
             </div>
          </b-col>
          <b-col md="6">
            <label class="form-control-label">
              Or choose a color
            </label>
            <div class="form__input color-picker">
              <v-swatches
                v-model="model.colorChoice"
                popover-x="right"
                popover-y="bottom"
                swatches="text-advanced"
              ></v-swatches>
            </div>
          </b-col>
          <b-col md="2">
            <label class="form-control-label">
              Active?
            </label><br />
            <base-switch label="Is Active?"
                    name="isActive"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isActive">
            </base-switch>
          </b-col>
          <b-col md="2">
            <label class="form-control-label">
              Featured?
            </label><br />
            <base-switch label="Is Featured?"
                    name="isFeatured"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isFeatured">
            </base-switch>
          </b-col>
          <b-col md="2">
            <label class="form-control-label">
              Public?
            </label><br />
            <base-switch label="Is Public?"
                    name="isPublic"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isPublic">
            </base-switch>
          </b-col>
        </div>
        <base-button v-show="!loading" type="primary" native-type="submit">Save Collection</base-button>
        <base-button v-show="loading" type="primary" native-type="button">Please Wait <i class="fas fa-spinner fa-spin"></i></base-button>
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  //import DropzoneFileUpload from '../../components/Inputs/DropzoneFileUpload.vue';
  import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
  import Instructions from '../Components/Instructions.vue';
  import "vue-swatches/dist/vue-swatches.css"
  import VSwatches from 'vue-swatches'
  import uuid from 'uuid';
  import vue2Dropzone from 'vue2-dropzone'

  export default {
    name: "EditCollection",
    components: {
        HtmlEditor,
        VSwatches,
        vue2Dropzone,
        [Select.name]: Select,
        [Option.name]: Option,
        Instructions
    },
    data() {
      return {
        model: {
          title: '',
          image: [],
          colorChoice: '',
          isFeatured: false,
          isActive: true,
          isPublic: true
        },
        loading: false,
        dropzoneOptions: {
          url: 'https://as-uw-marlin-whipstir-api.azurewebsites.net/api/assets/uploadfile',
          thumbnailWidth: 450,
          thumbnailHeight: 200,
          uploadMultiple: false,
          maxFiles: 1,
          maxFilesize: 256,
          maxThumbnailFilesize: 256,
          autoProcessQueue: false,
          addRemoveLinks: true,
          headers: {'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjNiNzFlNzZiLTc3Y2ItNDIxMy1hY2NmLTZkYzg3ZTIyMGJjNSIsImNvbXBhbnlpZCI6ImRjZDMzZDA3LTZkNzctNGZiOS04NmQ5LTBiOWNiNWE4ODE1OSIsImNsaWVudGlkIjoiMTFiZDc5NWYtMzFmYS00NmYyLWJjMzgtYmY1N2E1ZGU2YTFiIiwibmJmIjoxNjI0MDM0ODI5LCJleHAiOjE2MjQ2Mzk2MjksImlhdCI6MTYyNDAzNDgyOX0.Zuv_tqHUep9jCiTmbZDOUEnXHwHBvfeMbWlopwyw3gw'},
        }
      }
    },
    computed: {
      isLoading() {
        return this.$store.state.collections.loading
      }
    },
    methods: {
      firstFormSubmit() {
        const { dispatch } = this.$store;
        if ( this.$refs.image.dropzone.files[0] ) {
          this.model.imageUpload = this.$refs.image.dropzone.files[0]
        }

        delete this.model.image;
       
        if (this.model.title) {
          try {
              dispatch("collections/addCollection", this.model)
                  .then(response => {
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error: collection edit", error);
          }
        }
      },
      maxFilesExceeded(file) {
        this.$refs.image.removeAllFiles()
        this.$refs.image.addFile(file)
        this.model.mainImage = file
      },
      fileAdded(file) {
        this.model.mainImage = file
      }
    },
    watch: {
      isLoading(newLoad) {
        if (newLoad == 'Saved') {
          this.$router.push({path: `/collections`});
          this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Collection Added'});
        }
        this.loading = newLoad
      }
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
</style>
